import {
  Draft,
  DraftComplete,
  DraftCompleteSchema,
  DraftPartial,
} from '../common.type';

export const ensureIsDraftComplete = (
  d: Draft | DraftPartial
): d is DraftComplete => {
  try {
    DraftCompleteSchema.parse(d);
    return true;
  } catch (err) {
    return false;
  }
};
